import { IRigHistory } from '../../interfaces/irig-history';
import { Rig } from '../rig';
import { RigRateType } from '../rig-rate-type';

export class RigHistoryBase {
  RigHistoryId: number;
  RigId: number;
  StartDate: Date;
  EndDate: Date;
  RigRateTypeId: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Rig?: Rig;
  RigRateType?: RigRateType;

  constructor(item?: IRigHistory) {
    if (item) {

      this.RigHistoryId = item.RigHistoryId;
      this.RigId = item.RigId;
      this.StartDate = item.StartDate ? new Date(item.StartDate) : null;
      this.EndDate = item.EndDate ? new Date(item.EndDate) : null;
      this.RigRateTypeId = item.RigRateTypeId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Rig = new Rig(item.Rig);
      this.RigRateType = new RigRateType(item.RigRateType);
    }
  }
}